import BarGraphWidgetView from './BarGraphWidgetView.vue';

export const type = 'barGraph';
export const view = BarGraphWidgetView;

export function builder() {
  return {
    type,
    left: 0,
    top: 0,
    rotate: 0,
    height: 300,
    width: 350,
    background: '#FFFFFF',
  };
}
